<template>
  <v-dialog :value="value" max-width="500" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="onCancel">
          {{ cancelLabel }}
        </v-btn>
        <v-btn text :loading="isLoading" @click="onDelete">
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      required: true,
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: 'Are you sure you want to delete this item?',
    },
    confirmLabel: {
      type: String,
      default: 'OK',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const onCancel = () => {
      emit('cancel')
    }

    const onDelete = () => {
      emit('delete', props.item)
    }

    return {
      title: props.title || `Delete item #${props.item?.id ?? ''}`,
      message: props.message,
      confirmLabel: props.confirmLabel,
      cancelLabel: props.cancelLabel,
      onCancel,
      onDelete,
    }
  },
}
</script>
